import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}



const routes= [
    //pc
    {
    		path: '',
        name:'Index',
    		component: () =>
    		  import('@/views/index/home.vue')
    },
    {
    		path: '/Index',
        name:'Index1',
    		component: () =>
    		  import('@/views/index/home.vue')
    },
    {
      path: '/',
      component: () =>
        import('@/views/index/home.vue')
    },
    {
      path: '/home',
      name: 'Home',
      component: () =>
        import('@/views/index/home.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import('@/views/login.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () =>
        import('@/views/register.vue')
    },
    {
      path: '/password',
      name: 'Password',
      component: () =>
        import('@/views/password.vue')
    },
    {
      path: '/eduActivity',
      name: 'EduActivity',
      component: () =>
        import('@/views/eduActivity/index.vue'),
      redirect:{name:'EduList'},
      children:[
        {
          path:'eduList',
          name:'EduList',
          component:() =>
            import('@/views/eduActivity/eduList.vue'),
        },
        {
          path:'eduInfo',
          name:'EduInform',
          component:() =>
            import('@/views/eduActivity/info.vue'),
        },
        {
          path:'info',
          name:'EduInfo',
          component:() =>
            import('@/views/eduActivity/inform.vue'),
        },
        {
          path:'infopxb',
          name:'EduInfopxb',
          component:() =>
            import('@/views/eduActivity/informpxb.vue'),
        },
        {
          path:'infojy',
          name:'EduInfojy',
          component:() =>
            import('@/views/eduActivity/informjy.vue'),
        },
        {
          path:'informCom',
          name:'EduInformCom',
          component:() =>
            import('@/views/eduActivity/informCom.vue'),
        },
        {
          path:'add',
          name:'EduAdd',
          component:() =>
            import('@/views/eduActivity/add.vue'),
        },
        {
          path:'comadd',
          name:'EduComAdd',
          component:() =>
            import('@/views/eduActivity/comadd.vue'),
        },
        {
          path:'pxadd',
          name:'PxAdd',
          component:() =>
            import('@/views/eduActivity/pxadd.vue'),
        },
        {
          path:'rmadd',
          name:'RmAdd',
          component:() =>
            import('@/views/eduActivity/rmadd.vue'),
        },
        {
          path:'hint',
          name:'EduHint',
          component:() =>
            import('@/views/eduActivity/hint.vue'),
        },
      ]

    },
    {
      path: '/consult',
      name: 'Consult',
      component: () =>
        import('@/views/consult/index.vue'),
      redirect:{name:'ConsultInfo'},
      children:[
        {
          path:'consultInfo',
          name:'ConsultInfo',
          component:() =>
            import('@/views/consult/consult.vue'),
        },
        {
          path:'questionList',
          name:'ConsultQuestion',
          component:() =>
            import('@/views/consult/questionList.vue'),
        },
        {
          path:'questionnaire',
          name:'Questionnaire',
          component:() =>
            import('@/views/consult/questionnaire.vue'),
        }
      ]
    },
    {
      path: '/knowledge',
      name: 'Knowledge',
      component: () =>
        import('@/views/knowledge/index.vue'),
      redirect:{name:'KnowList'},
      children:[
        {
          path:'knowList',
          name:'KnowList',
          component:() =>
            import('@/views/knowledge/knowList.vue'),
        },
        {
          path:'detail',
          name:'NavigationDetail',
          component:() =>
            import('@/views/knowledge/detail.vue'),
        },
        {
          path:'techDetail',
          name:'TechDetail',
          component:() =>
            import('@/views/knowledge/techDetail.vue'),
        },
        {
          path:'knowAudio',
          name:'KnowAudio',
          component:() =>
            import('@/views/knowledge/audio.vue'),
        },
      ]
    },
    // {
    //   path: '/knowDetail',
    //   name: 'KnowDetail',
    //   component: () =>
    //     import('@/views/knowledge/detail.vue')
    // },
    {
      path: '/navigation',
      name: 'Navigation',
      component: () =>
        import('@/views/navigation/index.vue'),
      redirect:{name:'NavigationInfo'},
      children:[
        {
          path:'navigationInfo',
          name:'NavigationInfo',
          component:() =>
            import('@/views/navigation/navigation.vue'),
        },
        {
          path:'tempList',
          name:'TempList',
          component:() =>
            import('@/views/navigation/tempList.vue'),
        },

        {
          path:'commonList',
          name:'CommonList',
          component:() =>
            import('@/views/navigation/commonList.vue'),
        },
        {
          path:'commonMore',
          name:'CommonMore',
          component:() =>
            import('@/views/navigation/commonMore.vue'),
        },
        {
          path:'specialList',
          name:'SpecialList',
          component:() =>
            import('@/views/navigation/specialList.vue'),
        },
        {
          path:'/navigation/specialDetail',
          name:'SpecialDetail',
          component:() =>
            import('@/views/navigation/specialDetail.vue'),
        },
      ]
    },

    {
      path:'/navigation/commonDetail',
      name:'CommonDetail',
      component:() =>
        import('@/views/navigation/commonDetail.vue'),
    },
    {
      path:'/navigation/tempDetail',
      name:'TempDetail',
      component:() =>
        import('@/views/navigation/tempDetail.vue'),
    },
    {
      path:'/navigation/tempPurchase',
      name:'TempPurchase',
      component:() =>
        import('@/views/navigation/tempPurchase.vue'),
    },
    {
      path: '/information',
      name: 'Information',
      component: () =>
        import('@/views/information/index.vue'),
      redirect:{name:'InfoList'},
      children:[
        {
          path:'infoList',
          name:'InfoList',
          component:() =>
            import('@/views/information/infoList.vue'),
        },
        {
          path:'infoDetail',
          name:'InformationDetail',
          component:() =>
            import('@/views/information/detail.vue'),
        }
      ]
    },
    {
      path: '/personCenter',
      name: 'PersonCenter',
      component: () =>
        import('@/views/personCenter/index.vue'),
      redirect:{name:'PersonInfo'},
      children:[
        {
          path:'personInfo',
          name:'PersonInfo',
          component:() =>
            import('@/views/personCenter/personInfo.vue'),
        },
        {
          path:'account',
          name:'Account',
          component:() =>
            import('@/views/personCenter/account.vue'),
        },
        {
          path:'volunteer',
          name:'PersonVolunteer',
          component:() =>
            import('@/views/personCenter/personvolunteer.vue'),
        }
      ]
    },
    {
      path: '/member',
      name: 'Member',
      component: () =>
        import('@/views/member/index.vue'),
        redirect: {name: 'Member'},
        children: [{
          path: 'outperiod',
          name: 'Outperiod',
          component: () =>
            import('@/views/member/components/outperiod.vue')
        },{
          path: 'member',
          name: 'Member',
          component: () =>
            import('@/views/member/components/buyMember.vue')
        },{
          path: 'memberMall',
          name: 'MemberMall',
          component: () =>
            import('@/views/member/components/memberMall.vue')
        },{
          path: 'memberMallDetail',
          name: 'MemberMallDetail',
          component: () =>
            import('@/views/member/components/memberMallDetail.vue')
        },{
          path: 'memberWelfare',
          name: 'MemberWelfare',
          component: () =>
            import('@/views/member/components/memberWelfare.vue')
        },{
          path: 'memberWelfareDetail',
          name: 'MemberWelfareDetail',
          component: () =>
            import('@/views/member/components/memberWelfareDetail.vue')
        },{
          path: 'memberOrder',
          name: 'MemberOrder',
          component: () =>
            import('@/views/member/components/memberOrder.vue')
        },{
          path: 'memberOrderDetail',
          name: 'MemberOrderDetail',
          component: () =>
            import('@/views/member/components/memberOrderDetail.vue')
        },{
          path: 'memberIntegral',
          name: 'MemberIntegral',
          component: () =>
            import('@/views/member/components/memberIntegral.vue')
        }]
    },
    {
      path: '/overview',
      name: 'Overview',
      component: () =>
        import('@/views/overview/index.vue'),
      redirect:{name:'OverviewInfo'},
      children:[
        {
          path:'overviewInfo',
          name:'OverviewInfo',
          component:() =>
            import('@/views/overview/overview.vue'),
        },
        {
          path:'overviewDetail',
          name:'OverviewDetail',
          component:() =>
            import('@/views/overview/detail.vue'),
        },
      ]
    },
    {
      path: '/cinema',
      name: 'Cinema',
      component: () =>
        import('@/views/cinema/index.vue'),
      redirect:{name:'CinemaInfo'},
      children:[
        {
          path:'inform',
          name:'CinemaInfo',
          component:() =>
            import('@/views/cinema/inform.vue'),
        },
        {
          path:'purchase',
          name:'CinemaPurchase',
          component:() =>
            import('@/views/cinema/purchase.vue'),
        }
      ]

    },
    {
      path: '/cinemaTicket',
      name: 'CinemaTicket',
      component: () =>
        import('@/views/cinema/index.vue')
    },
    {
      path: '/selfAppoint',
      name: 'Self',
      component: () =>
        import('@/views/selfAppoint/index.vue'),
      redirect:{name:'SelfInfo'},
      children:[
        {
          path:'info',
          name:'SelfInfo',
          component:() =>
            import('@/views/selfAppoint/info.vue'),
        },
        {
          path:'selfAppoint',
          name:'SelfAppoint',
          component:() =>
            import('@/views/selfAppoint/appoint.vue'),
        },
        {
          path:'selfAdd',
          name:'SelfAdd',
          component:() =>
            import('@/views/selfAppoint/add.vue'),
        },
        {
          path:'selfHint',
          name:'SelfHint',
          component:() =>
            import('@/views/selfAppoint/hint.vue'),
        }
      ]
    },
    {
      path: '/team',
      name: 'Team',
      component: () =>
        import('@/views/teamAppoint/index.vue'),
      redirect:{name:'TeamInfo'},
      children:[
        {
          path:'info',
          name:'TeamInfo',
          component:() =>
            import('@/views/teamAppoint/info.vue'),
        },
        {
          path:'teamAppoint',
          name:'TeamAppoint',
          component:() =>
            import('@/views/teamAppoint/appoint.vue'),
        },
        {
          path:'teamAdd',
          name:'TeamAdd',
          component:() =>
            import('@/views/teamAppoint/add.vue'),
        },
        {
          path:'teamHint',
          name:'TeamHint',
          component:() =>
            import('@/views/teamAppoint/hint.vue'),
        }
      ]

    },
    {
      path: '/volunteer',
      name: 'Volunteer',
      component: () =>
        import('@/views/volunteer/index.vue'),
      redirect:{name:'VolunteerInfo'},
      children:[
        {
          path:'info',
          name:'VolunteerInfo',
          component:() =>
            import('@/views/volunteer/info.vue'),
        },
        {
          path:'volunteerAppoint',
          name:'VolunteerAppoint',
          component:() =>
            import('@/views/volunteer/appoint.vue'),
        },
        {
          path:'volunteerAdd',
          name:'VolunteerAdd',
          component:() =>
            import('@/views/volunteer/add.vue'),
        },
        {
          path:'volunteerHint',
          name:'VolunteerHint',
          component:() =>
            import('@/views/volunteer/hint.vue'),
        }
      ]

    },
    {
      path: '/search',
      name: 'Search',
      component: () =>
        import('@/views/search/index.vue'),
      redirect:{name:'SearchInfo'},
      children:[
        {
          path:'searchInfo',
          name:'SearchInfo',
          component:() =>
            import('@/views/search/info.vue'),
        }
      ]
    },
    // {
    //   path: '/test',
    //   name: 'test',
    //   component: () =>
    //     import('@/views/test.vue'),
    // },

    //移动端
    {
      path: '/mIndex',
      name: 'mIndex',
      component: () =>
        import('@/views/mindex/index.vue'),
    },
    {
      path: '/moverview/overviewInfo',
      name: 'mOverview',
      component: () =>
        import('@/views/moverview/index.vue'),
    },
    {
      path: '/mnavigation',
      name: 'mNavigation',
      component: () =>
        import('@/views/mnavigation/index.vue'),
      redirect:{name:'mNavigationInfo'},
      children:[
        {
          path:'navigationInfo',
          name:'mNavigationInfo',
          component:() =>
            import('@/views/mnavigation/navigation.vue'),
        },
        {
          path:'tempList',
          name:'mTempList',
          component:() =>
            import('@/views/mnavigation/tempList.vue'),
        },

        {
          path:'commonList',
          name:'mCommonList',
          component:() =>
            import('@/views/mnavigation/commonList.vue'),
        },
        {
          path:'commonMore',
          name:'mCommonMore',
          component:() =>
            import('@/views/mnavigation/commonMore.vue'),
        },
        {
          path:'specialList',
          name:'mSpecialList',
          component:() =>
            import('@/views/mnavigation/specialList.vue'),
        },
        {
          path:'/mnavigation/specialDetail',
          name:'mSpecialDetail',
          component:() =>
            import('@/views/mnavigation/specialDetail.vue'),
        }
      ]
    },
    {
      path:'/mnavigation/commonDetail',
      name:'mCommonDetail',
      component:() =>
        import('@/views/mnavigation/commonDetail.vue'),
    },
    {
      path:'/mnavigation/tempDetail',
      name:'mTempDetail',
      component:() =>
        import('@/views/mnavigation/tempDetail.vue'),
    },
    {
      path: '/mknowledge',
      name: 'mKnowledge',
      component: () =>
        import('@/views/mknowledge/index.vue'),
      redirect:{name:'mKnowList'},
      children:[
        {
          path:'knowList',
          name:'mKnowList',
          component:() =>
            import('@/views/mknowledge/knowList.vue'),
        },
        {
          path:'detail',
          name:'mNavigationDetail',
          component:() =>
            import('@/views/mknowledge/detail.vue'),
        },
        {
          path:'techDetail',
          name:'mTechDetail',
          component:() =>
            import('@/views/mknowledge/techDetail.vue'),
        },
        {
          path:'knowAudio',
          name:'mKnowAudio',
          component:() =>
            import('@/views/mknowledge/audio.vue'),
        },
      ]
    },
    {
      path:'/mconsult/consultInfo',
      name:'mConsult',
      component:() =>
        import('@/views/mconsult/index.vue'),
      // children:[
      //   {
      //     // path:'mconsultInfo',
      //     // name:'mConsultInfo',
      //     // component:() =>
      //     //   import('@/views/mconsult/consult.vue'),
      //   },
      //   // {
      //   //   path:'questionList',
      //   //   name:'ConsultQuestion',
      //   //   component:() =>
      //   //     import('@/views/consult/questionList.vue'),
      //   // },
      //   // {
      //   //   path:'questionnaire',
      //   //   name:'Questionnaire',
      //   //   component:() =>
      //   //     import('@/views/consult/questionnaire.vue'),
      //   // }
      // ]
    },
    {
      path: '/meduActivity',
      name: 'mEduActivity',
      component: () =>
        import('@/views/meduActivity/index.vue'),
      redirect:{name:'mEduList'},
      children:[
        {
          path:'eduList',
          name:'mEduList',
          component:() =>
            import('@/views/meduActivity/eduList.vue'),
        },
        {
          path:'eduInfo',
          name:'mEduInform',
          component:() =>
            import('@/views/meduActivity/info.vue'),
        }
      ]

    },
    {
      path: '/minformation',
      name: 'mInformation',
      component: () =>
        import('@/views/minformation/index.vue'),
      redirect:{name:'mInfoList'},
      children:[
        {
          path:'infoList',
          name:'mInfoList',
          component:() =>
            import('@/views/minformation/infoList.vue'),
        },
        {
          path:'infoDetail',
          name:'mInformationDetail',
          component:() =>
            import('@/views/minformation/detail.vue'),
        }
      ]
    },
  ]




const router = new Router({
	mode: 'history',
	// base: process.env.BASE_URL,
	routes,
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js